import { render } from "./AppFooter.vue?vue&type=template&id=7601a5d4"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\Arenal\\ViajesControl\\Arenal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__